let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined,
  search_strategy_id: undefined,
  code: "",
  name: {
    vi: "",
    en: "",
  },
  input_type: undefined,
  default_value_label: {
    vi: "",
    en: "",
  },
  source: {
    from: undefined,
    json: "",
    sql: "",
  },
  index: undefined,
  width: undefined,
  tooltip: "",
};

model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "index",
  defaultSort: ["index", "ascending"],
  fields:
    "id,search_strategy_id,code,name,input_type,default_value_label,source,index,width,tooltip",
  filters: "",
  dataSearch: {
    value: {
      code: "",
      "name.vi": "",
      "name.en": "",
      input_type: "",
      search_strategy_id: "",
    },
    operator: {
      code: ":regex_i:",
      "name.vi": ":regex_i:",
      "name.en": ":regex_i:",
      input_type: "=",
      search_strategy_id: "=",
    },
  },
};

model.inputTypeOptions = [
  {
    value: "dropdown",
    labelKey: "t-input-type-dropdown",
  },
  {
    value: "textbox",
    labelKey: "t-input-type-textbox",
  },
];

model.sourceFromOptions = [
  {
    value: "json",
    labelKey: "t-source-from-json",
  },
  {
    value: "sql",
    labelKey: "t-source-from-sql",
  },
];

export default model;
